<template>
  <div
    v-if="state.activeState === '1'"
    class="feedback-icon-wrapper"
    :class="{ 'feedback-icon-wrapper-mobile': isMobile }"
    :style="{ bottom: isMobile ? `${bottom}rem` : `${bottom}px`}"
    @click="onShowPop"
  >
    <img class="icon" src="/image/feedback-icon.svg" alt="icon">
    <div class="feedback-pop" :class="{'hidden': !state.showPop}">
      <img class="close-btn" src="@/assets/icon/close.svg" alt="close" @click.stop="onClose()">
      <div class="title">{{ state.title }}</div>
      <div class="descripion">{{ state.description }}</div>
      <a href="javascript:void(0);" class="start-btn" @click.stop="onLink()">{{ $t("home.start") }}</a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted } from 'vue'
import { useClientCompatibleHook } from '@/utils/hooks'
import { getSiteFeedback } from '@/request/api/common'
import { CookieUtil } from '@/utils'

export default defineComponent({
  components: {
  },
  props: [],
  setup () {
    const { isMobile } = useClientCompatibleHook()
    const BASIC_BOTTOM = isMobile.value ? 10.8 : 262
    const bottom = ref(BASIC_BOTTOM)
    const state = reactive({
      showPop: false,
      title: '',
      description: '',
      link: '',
      activeState: ''
    })
    const onShowPop = () => {
      state.showPop = true
    }
    const onClose = () => {
      state.showPop = false
      CookieUtil.setCookie('feedbackPopupVisible', 'false', CookieUtil.FORMAT_TIME.WEEK)
    }
    onMounted(() => {
      getSiteFeedback().then(res => {
        if (res && res.data) {
          const { title, description, link, activeState } = res.data as { title: string, description: string, link: string, activeState: string }
          state.title = title
          state.description = description
          state.link = link
          state.activeState = activeState
        }
      })
    })
    const feedbackPopupVisible = CookieUtil.getCookie('feedbackPopupVisible') === 'false'
    if (feedbackPopupVisible) {
      state.showPop = false
    } else {
      state.showPop = true
      CookieUtil.setCookie('feedbackPopupVisible', 'true')
    }
    const onLink = () => {
      window.open(state.link, '_blank')
      onClose()
    }
    return {
      bottom,
      isMobile,
      state,
      onShowPop,
      onClose,
      onLink
    }
  }
})
</script>

<style scoped lang="less">
.feedback-icon-wrapper {
  position: fixed;
  right: 30px;
  z-index: 999;
  width: 50px;
  height: 50px;
  background-image: linear-gradient(180deg, #F8F8F8 0%, #FFFFFF 51%, #F8F8F8 100%);
  border: 2px solid rgba(255,255,255,1);
  box-shadow: 0px 0px 11px 0px rgba(55,99,170,0.16);
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .icon {
    width: 30px;
  }
  .feedback-pop{
    position: absolute;
    bottom: 58px;
    right: 0px;
    min-height: 188px;
    width: 400px;
    padding: 40px 28px 24px 28px;
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(234, 234, 234);
    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.07);
    text-align: center;
    transition: all .5s;
    cursor: default;
    &.hidden{
      transform: scale(0.001);
      bottom: -106px;
      right: -176px;
      z-index: -1;
    }
    .close-btn{
      position: absolute;
      top: 14px;
      right: 14px;
      width: 20px;
      opacity: 0.5;
      cursor: pointer;
    }
    .title{
      font-size: 20px;
      font-weight: 700;
      line-height: 27px;
      margin-bottom: 20px;
    }
    .descripion{
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      margin-bottom: 20px;
    }
    .start-btn{
      width: 88px;
      height: 32px;
      line-height: 32px;
      background: rgb(215, 21, 14);
      border-radius: 16px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      display: block;
      margin: 0 auto;
    }
  }
}

.feedback-icon-wrapper-mobile {
  width: 4.4rem;
  height: 4.4rem;
  right: 0.4rem;
  .icon {
    width: 2.5rem;
  }
  .feedback-pop{
    position: fixed;
    bottom: 0;
    width: 100%;
    min-height: 14.2rem;
    padding: 16px;
    color: rgb(51, 51, 51);
    transition:none;
    &.hidden{
      display: none;
    }
    .close-btn{
      width: 14px;
    }
    .title{
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 16px;
    }
    .descripion{
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 16px;
    }
  }
}
.rtl--container {
  .feedback-icon-wrapper{
    right: auto;
    left: 30px;
    .feedback-pop {
      right: auto;
      left: 0px;
      // 点击按钮元素由大变小有过渡时间，这里不直接使用display:none;
      &.hidden{
        transform: scale(0.001);
        bottom: -106px;
        right: auto;
        left: -176px;
        z-index: -1;
      }
    }
    .close-btn {
      right: auto;
      left: 14px;
    }
  }
  .feedback-icon-wrapper-mobile {
    left: 0.4rem;
  }
}

</style>
